export default class Default {
  constructor(main, shopify) {
    this.u = main.utils;
    this.s = shopify;

    //Default ajax settings
    this._defaults = shopify._ajax_defaults;
  }

  
  get(opts) {
    var url      = '/cart.js';
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : JSON.stringify(data),
      type : 'GET',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }

  
  add(opts) {
    var url      = '/cart/add.js';
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : data,
      contentType: 'application/x-www-form-urlencoded',
      type : 'POST',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }

  
  update(opts) {
    var url      = '/cart/update.js';
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : data,
      contentType: 'application/x-www-form-urlencoded',
      type : 'POST',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }

  
  clear(opts) {
    var url      = '/cart/clear.js';
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : JSON.stringify(data),
      type : 'POST',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }
}